import {
  Form,
  Space,
  message,
} from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';

import { addAdminUserService } from '../../services/adminUsersService';
import UsersForm from '../../forms/UsersForm';

function AddAdminUser() {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const response = await addAdminUserService(values);
      if (response?.status === 'success') {
        message.success('მომხმარებელი წარმატებით დაემატა');
        navigate('/admin/users');
      }
    } catch (error) {
      setErrors(error?.response?.data?.errors || {});
    }
  };

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <ArrowLeftOutlined
        style={{ fontSize: '20px' }}
        onClick={() => navigate('/admin/users')}
      />
      <UsersForm errors={errors} onFinish={onFinish} form={form} />
    </Space>
  );
}

export default AddAdminUser;
